/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';
import { v4 as uuidv4 } from 'uuid';
import {
  getSpan,
  getTypeNameBySpan
} from '../../../components/Visualizer/utils';
import logNewRelicCustom from '../../../utils/logNewRelicCustom';
import { NEW_RELIC_EVENTS } from '../../../constants';

export default (set, get, choiceId, choiceMetaData, origin) => set(
  produce(
    get(),
    (draft) => {
      // data
      const {
        Sku: sku,
        GridSpan: gridSpan,
        ProductType: productType
      } = choiceMetaData;
      const span = getSpan(gridSpan);

      // transform
      const enhancedProduct = {
        choiceId,
        Origin: origin,
        Sku: sku,
        stackItemId: uuidv4(),
        type: productType === 'Base' ? 'Base' : getTypeNameBySpan(span),
        choiceBundle: null,
      };
      if (!draft.design) {
        draft.design = {};
      }

      // update state
      draft.design.products.push(enhancedProduct);
      draft.design.selectedProduct = null;

      if (draft.design.isFromPip && draft.design.products.length > 1) {
        draft.design.isFromPip = false;
      }

      // logging
      logNewRelicCustom(NEW_RELIC_EVENTS.PRODUCT_ADDED, enhancedProduct);
    }),
  false,
  { type: 'ADD', payload: {} }
);
